// Shared contact channels. The floating WhatsAppButton and the /join help
// links read the WhatsApp URL from here so they can't drift apart.
export const WHATSAPP_URL = 'https://wa.me/+442080582710';
